import React, {Dispatch, SetStateAction, useCallback} from "react";
import {createPortal} from "react-dom";
import {LoadingBackdrop} from "../LoadingBackdrop/LoadingBackdrop";
import Modal from "../Modal/Modal";
import {Form} from "../form/Form/Form";
import * as TextField from "../form/TextField/TextField";
import {getFilledFieldsObjOnFormSubmit, isErrorResponse} from "../../utils/utils";
import {useProjectContext} from "../../context/ProjectContext";
import {useToastContext} from "../../context/toastContext";
import {ProjectEntity} from "../../api/entities";
import {useTranslation} from "react-i18next";


type Props = {
    project: ProjectEntity;
    setProjectEditing: Dispatch<SetStateAction<ProjectEntity | null>>;
}

const ProjectEditor = ({project, setProjectEditing}: Props) => {
    const [saving, setSaving] = React.useState(false);
    const {updateProject} = useProjectContext();
    const {addToast} = useToastContext();
    const {t} = useTranslation();

    const closeModal = useCallback((visible: boolean) => {
        setProjectEditing(null);
    }, [setProjectEditing])

    const onFormSubmit = useCallback(async (event) => {
        setSaving(true);

        const formDataObj = getFilledFieldsObjOnFormSubmit(event)
        const resp = await updateProject(project.id, formDataObj)

        if (isErrorResponse(resp)) {
            addToast(`${resp.error_description}`, 'error');
        } else {
            addToast(t('common.save-successful'), 'success');
        }

        setSaving(false);
        closeModal(true);
    }, [project, closeModal])

    return (
        <>
            createPortal(
            <LoadingBackdrop isVisible={saving} transparent>
                <Modal
                    title={t('projects-main.update-project-modal-title')}
                    setVisible={closeModal}
                >
                    <Form
                        name="form"
                        onSubmit={onFormSubmit}
                        submitBtnTitle={t('common.save')}
                    >
                        <TextField.Labeled
                            name="projectName"
                            label={t('projects-main.update-project-modal-new-name-field')}
                            value={project.projectName}
                            type="text"
                            required={true}
                        />
                    </Form>
                </Modal>
            </LoadingBackdrop>
            , document.getElementById('root') as any
            )
        </>
    )
}

export default ProjectEditor;